export default {
  title: "Favorite List of Recruitment Cases",
};
